import type { ExplicitIngressOutcome, LegacyIngressDefinition } from './types'

import { useEnv } from '@/shared/config'
import { pushToDataLayer, type DataLayerEvent } from '@/shared/lib/analytics/gtm'

export interface IngressOutcomeTelemetry extends DataLayerEvent {
  event: 'legacy_ingress_outcome'
  event_type: 'Core'
  ingress_id: string
  ingress_kind: ExplicitIngressOutcome['kind']
}

export function ingressOutcomeTelemetry(
  definition: LegacyIngressDefinition & { outcome: ExplicitIngressOutcome },
): IngressOutcomeTelemetry {
  return {
    event: 'legacy_ingress_outcome',
    event_type: 'Core',
    ingress_id: definition.id,
    ingress_kind: definition.outcome.kind,
  }
}

/** Emits identifiers only: attempted path/query/hash and customer payloads never enter telemetry. */
export function trackIngressOutcome(
  definition: LegacyIngressDefinition & { outcome: ExplicitIngressOutcome },
): void {
  const env = useEnv()
  if (env.MODE !== 'production' || !env.GTM_ID) return
  pushToDataLayer(ingressOutcomeTelemetry(definition))
}
